import React, { useEffect, useState } from "react";
import { Box, Button, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "components/Header";
import axios from "axios";
import { server } from "server";
import FormProductStock from "scenes/formProductStock";
import Popup from "components/Popup";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetUserQuery } from "state/api";

const PendingProduct = () => {
  const theme = useTheme();
  const [openPopup, setOpenPopup] = useState(false);
  const [pendingProducts, setPendingProducts] = useState([]);
  const userId = useSelector((state) => state.global.userId);
  const { data } = useGetUserQuery(userId);

  useEffect(() => {
    const fetchPendingProducts = async () => {
      try {
        await axios.get(`${server}/product/pendingProducts`).then((res) => {
          setPendingProducts(res.data);
        });
      } catch (error) {
        console.error("Error fetching pending products:", error);
      }
    };
    fetchPendingProducts();
  }, []);
  const formatNumber = (number) => {
    return number.toLocaleString();
  };

  const columns = [
    { field: "createdAt", headerName: "Created At", flex: 1 },
    { field: "name", headerName: "Name", flex: 1 },
    { field: "categorie", headerName: "Categorie", flex: 1 },
    { field: "desc", headerName: "Description", flex: 1 },
    { field: "price_vente", headerName: "Prix de Vente", flex: 2 },
    { field: "userName", headerName: "Effectue par", flex: 1 },

    { field: "status", headerName: "Status", flex: 1 },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => (
        <>
          {data?.role === "superadmin" ||
          data?.role === "admin" ||
          data?.role === "caissiere" ? (
            <Link to={"/PendingProductEdit/" + params.row.id}>
              <Button
                color="secondary"
                variant="contained"
                style={{ marginBottom: "6px" }}
              >
                Edit
              </Button>
            </Link>
          ) : (
            ""
          )}
        </>
      ),
    },
  ];

  const row = [];
  pendingProducts &&
    pendingProducts.forEach((item) => {
      row.push({
        id: item._id,
        name: item.name,
        cattegorie: item.category,
        desc: item.desc,
        price_vente: formatNumber(item.price_vente),
        userName: item.userName,
        status: "En attente",
        stock: item.stock,
        createdAt: item.createdAt.slice(0, 10),
      });
    });

  return (
    <Box m="1.5rem 2.5rem">
      <Header
        title="Stocks"
        subtitle="Liste des Produits retires dans le stock"
      />
      <Box
        height="80vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <DataGrid
          rows={row}
          columns={columns}
          components={{ Toolbar: DataGridCustomToolbar }}
          componentsProps={{
            toolbar: { openPopup, setOpenPopup },
          }}
        />
      </Box>
      <Popup
        title="Fromulaire d'un produit"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <FormProductStock setOpenPopup={setOpenPopup} />
      </Popup>
    </Box>
  );
};

export default PendingProduct;
